import { render, staticRenderFns } from "./Curriculum.vue?vue&type=template&id=22a3b5f2&scoped=true"
import script from "./Curriculum.vue?vue&type=script&lang=js"
export * from "./Curriculum.vue?vue&type=script&lang=js"
import style0 from "./Curriculum.vue?vue&type=style&index=0&id=22a3b5f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a3b5f2",
  null
  
)

export default component.exports